import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

// Drives the single per-index "Delete session" confirmation (TMS-1303). Each
// row's Delete hands over its session id and title; the form is pointed at
// that session and submits a soft delete (DELETE → archive).
export default class extends Controller {
  static targets = ["modal", "form", "sessionTitle"];
  static values = {
    baseUrl: String
  };

  open(event) {
    event.preventDefault();

    const { sessionId, sessionTitle } = event.currentTarget.dataset;

    this.formTarget.action = this.baseUrlValue.replace(":id", sessionId);
    this.sessionTitleTarget.textContent = sessionTitle;

    Modal.getOrCreateInstance(this.modalTarget).show();
  }
}
